import { Button } from '@/components/ui/button'
import { ClaimStatus, type InternalClaim } from '@/models/claim'
import { ClaimStatusNotesDialog } from './ClaimStatusNotesDialog'

// The steps on the customer's timeline; a note for Draft would never be read.
const NOTEABLE = [ClaimStatus.SUBMITTED, ClaimStatus.FILED, ClaimStatus.OPEN_WITH_CARRIER, ClaimStatus.CLOSED]

/** Carrier details and stage notes, as links beside the row's View / Edit. */
export function ClaimLifecycleLinks({
  claim,
  onOpenCarrier,
}: {
  claim: InternalClaim
  onOpenCarrier: (claim: InternalClaim) => void
}) {
  return (
    <>
      <Button variant="link" size="sm" className="h-auto px-0" onClick={() => onOpenCarrier(claim)}>
        Carrier
      </Button>
      <ClaimStatusNotesDialog claim={claim} statuses={NOTEABLE} />
    </>
  )
}
